import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { v4 as uuid } from 'uuid';
import cns from 'classnames';
import { Field } from 'redux-form';
import { Button } from 'react-bootstrap';
import ReactPlayer from 'react-player';

import RawImageUpload from '../../../../../../shared/components/formComponents/inputs/RawImageUpload';
import { VerbRichTextEditor } from '../../../../../../shared/components/formComponents/VerbRichTextEditor';
import BasicSelect from '../../../../../../shared/components/formComponents/groups/BasicSelect';
import BasicText from '../../../../../../shared/components/formComponents/groups/BasicText';

import BasicToggle from '../../../../../../shared/components/formComponents/groups/BasicToggle';

import { RICH_TEXT_LAYOUTS } from '../../../../../../shared/Constants';

class DynamicRichTextBlock extends Component {
    static propTypes = {
        fields: PropTypes.object,
        contentValues: PropTypes.object,
        layoutOptions: PropTypes.array,
        disabled: PropTypes.bool
    };

    _pushField = () => {
        const { fields } = this.props;

        if (fields.length <= 4) {
            fields.push({
                id: uuid(),
                wrapText: true
            });
        }
    };

    _removeField = (index) => {
        const { fields } = this.props;

        fields.remove(index);
    };

    _moveUp = (index) => {
        const { fields } = this.props;

        if (index) {
            fields.swap(index, index - 1);
        }
    };

    _moveDown = (index) => {
        const { fields } = this.props;

        if (index < fields.length - 1) {
            fields.swap(index, index + 1);
        }
    };

    _isValidURLSource = (value) => {
        const isValid =
            value && (ReactPlayer.canPlay(value) || (value.indexOf(`<iframe`) > -1 && value.indexOf(`</iframe>`) > -1));

        return isValid ? undefined : 'This is not a valid video source!';
    };

    _renderLayout = (name, index) => {
        const { contentValues = {}, disabled } = this.props;

        const blockLayout = contentValues.blocks && contentValues.blocks[index].layout;

        if (!blockLayout) {
            return null;
        }

        if (blockLayout === RICH_TEXT_LAYOUTS.TOP_TEXT_BOTTOM_IMAGE) {
            return (
                <Fragment>
                    <Field
                        name={`${name}.description`}
                        label={'Description'}
                        className={'col-12 richTextDescription'}
                        placeholder={'Enter a description'}
                        component={VerbRichTextEditor}
                        readOnly={disabled}
                        rows={3}
                    />
                    <Field
                        name={`${name}.imageUrl`}
                        label={'Image'}
                        className={'col-12 richTextImage'}
                        component={RawImageUpload}
                        showDeleteButton={true}
                        disabled={disabled}
                    />
                </Fragment>
            );
        }
        if (blockLayout === RICH_TEXT_LAYOUTS.TOP_TEXT_ONLY) {
            return (
                <Fragment>
                    <Field
                        name={`${name}.description`}
                        label={'Description'}
                        className={'col-12 richTextDescription'}
                        placeholder={'Enter a description'}
                        component={VerbRichTextEditor}
                        readOnly={disabled}
                        rows={3}
                    />
                </Fragment>
            );
        }
        if (blockLayout === RICH_TEXT_LAYOUTS.LEFT_TEXT_RIGHT_IMAGE) {
            return (
                <Fragment>
                    <div className={'row'}>
                        <div className={'col-6'}>
                            <Field
                                name={`${name}.description`}
                                label={'Left Text'}
                                className={'col-12 left-text'}
                                placeholder={'Enter left text.'}
                                component={VerbRichTextEditor}
                                readOnly={disabled}
                                rows={3}
                            />
                        </div>
                        <div className={'col-6'}>
                            <Field
                                name={`${name}.imageUrl`}
                                label={'Image'}
                                className={'col-12 richTextImage'}
                                component={RawImageUpload}
                                disabled={disabled}
                                showDeleteButton={true}
                            />
                        </div>
                    </div>
                </Fragment>
            );
        }
        if (blockLayout === RICH_TEXT_LAYOUTS.RIGHT_TEXT_LEFT_IMAGE) {
            return (
                <Fragment>
                    <div className={'row'}>
                        <div className={'col-6'}>
                            <Field
                                name={`${name}.imageUrl`}
                                label={'Image'}
                                className={'col-12 richTextImage'}
                                component={RawImageUpload}
                                disabled={disabled}
                                showDeleteButton={true}
                            />
                        </div>
                        <div className={'col-6'}>
                            <Field
                                name={`${name}.description`}
                                label={'Right Text'}
                                className={'col-12 right-text'}
                                placeholder={'Enter right text.'}
                                component={VerbRichTextEditor}
                                readOnly={disabled}
                                rows={3}
                            />
                        </div>
                    </div>
                </Fragment>
            );
        }
        if (blockLayout === RICH_TEXT_LAYOUTS.TOP_TEXT_BOTTOM_VIDEO) {
            return (
                <Fragment>
                    <Field
                        name={`${name}.description`}
                        label={'Description'}
                        className={'col-12 richTextDescription'}
                        placeholder={'Enter a description.'}
                        component={VerbRichTextEditor}
                        readOnly={disabled}
                        rows={3}
                    />
                    <Field
                        name={`${name}.videoUrl`}
                        label={'Video Link (YouTube, Vimeo, TED embedded video)'}
                        className={'col-12 richTextVideo'}
                        validate={this._isValidURLSource}
                        component={BasicText}
                        disabled={disabled}
                    />
                </Fragment>
            );
        }
        if (blockLayout === RICH_TEXT_LAYOUTS.TOP_TEXT_BOTTOM_AUDIO) {
            return (
                <Fragment>
                    <Field
                        name={`${name}.description`}
                        label={'Description'}
                        className={'col-12 richTextDescription'}
                        placeholder={'Enter a description.'}
                        component={VerbRichTextEditor}
                        readOnly={disabled}
                        rows={3}
                    />
                    <Field
                        name={`${name}.audioUrl`}
                        label={'SoundCloud Link'}
                        className={'col-12 richTextAudio'}
                        validate={this._isValidURLSource}
                        component={BasicText}
                        disabled={disabled}
                    />
                </Fragment>
            );
        }
        if (blockLayout === RICH_TEXT_LAYOUTS.TEXT_SIDE_BY_SIDE) {
            return (
                <Fragment>
                    <div className={'row'}>
                        <div className={'col-6'}>
                            <Field
                                name={`${name}.textSideA`}
                                label={'Left Side Text'}
                                className={'col-12 text-side-a'}
                                placeholder={'Enter left text...'}
                                component={VerbRichTextEditor}
                                readOnly={disabled}
                                rows={3}
                            />
                        </div>
                        <div className={'col-6'}>
                            <Field
                                name={`${name}.textSideB`}
                                label={'Right Side Text'}
                                className={'col-12 text-side-b'}
                                placeholder={'Enter left text...'}
                                component={VerbRichTextEditor}
                                readOnly={disabled}
                                rows={3}
                            />
                        </div>
                    </div>
                </Fragment>
            );
        }
        if (blockLayout === RICH_TEXT_LAYOUTS.CENTERED_TEXT) {
            return (
                <Fragment>
                    <Field
                        name={`${name}.description`}
                        label={'Description'}
                        className={'col-12 richTextDescription'}
                        placeholder={'Enter a description'}
                        component={VerbRichTextEditor}
                        readOnly={disabled}
                        rows={3}
                    />
                </Fragment>
            );
        }
        return null;
    };

    render() {
        const { fields, contentValues, layoutOptions, disabled } = this.props;

        const fieldsArray = fields.map((name, index) => (
            <div key={contentValues.blocks && contentValues.blocks[index].id} className={'dynamic-rich-text-block'}>
                <div className={'row'}>
                    <div className={'col-2'}>
                        <h5 className={'block-heading'}>{`SECTION ${index + 1}`}</h5>
                    </div>
                    <Button onClick={() => this._moveUp(index)} className={'drt-swap-up col-1'}>
                        <i className={'fa fa-angle-up'} />
                    </Button>
                    <Button onClick={() => this._moveDown(index)} className={'drt-swap-down col-1'}>
                        <i className={'fa fa-angle-down'} />
                    </Button>
                    <Button onClick={() => this._removeField(index)} className={'drt-delete col-1'}>
                        <i className={'fa fa-trash'} />
                    </Button>
                </div>
                <div className={'row'}>
                    <Field
                        name={`${name}.layout`}
                        label={'Choose Layout'}
                        className={'col-6 richTextLayouts'}
                        options={layoutOptions}
                        component={BasicSelect}
                        disabled={disabled}
                    />
                    <Field
                        name={`${name}.wrapText`}
                        label={'Wrap text around image'}
                        className={cns('col-md-3', {
                            hidden:
                                contentValues.blocks[index].layout !== RICH_TEXT_LAYOUTS.RIGHT_TEXT_LEFT_IMAGE &&
                                contentValues.blocks[index].layout !== RICH_TEXT_LAYOUTS.LEFT_TEXT_RIGHT_IMAGE
                        })}
                        disabled={disabled}
                        component={BasicToggle}
                        id={'wrap-text-toggle'}
                    />
                </div>
                <div className={'drt-layout'}>{this._renderLayout(name, index)}</div>
            </div>
        ));

        return (
            <div className={'row'}>
                <div className={'col-12'}>{fieldsArray}</div>

                <div className={'col-12'}>
                    <Button
                        onClick={this._pushField}
                        className={cns('chooseSectionItem-addField fa fa-plus fa-large', {
                            hidden: fields.length > 4 || disabled
                        })}
                    />
                </div>
            </div>
        );
    }
}

export default DynamicRichTextBlock;
